var components
try {
  components = {
    uTransition: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-transition/u-transition" */ "@/uni_modules/uview-ui/components/u-transition/u-transition.vue"
      )
    },
    uIcon: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-icon/u-icon" */ "@/uni_modules/uview-ui/components/u-icon/u-icon.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var s0 = _vm.__get_style([_vm.wrapStyle, _vm.backgroundStyle])
  var g0 =
    !_vm.isError && !(_vm.shape == "circle") ? _vm.$u.addUnit(_vm.radius) : null
  var g1 = !_vm.isError ? _vm.$u.addUnit(_vm.width) : null
  var g2 = !_vm.isError ? _vm.$u.addUnit(_vm.height) : null
  var g3 =
    _vm.showLoading && _vm.loading && !(_vm.shape == "circle")
      ? _vm.$u.addUnit(_vm.radius)
      : null
  var g4 = _vm.showLoading && _vm.loading ? _vm.$u.addUnit(_vm.width) : null
  var g5 = _vm.showLoading && _vm.loading ? _vm.$u.addUnit(_vm.height) : null
  var g6 =
    _vm.showError && _vm.isError && !_vm.loading && !(_vm.shape == "circle")
      ? _vm.$u.addUnit(_vm.radius)
      : null
  var g7 =
    _vm.showError && _vm.isError && !_vm.loading
      ? _vm.$u.addUnit(_vm.width)
      : null
  var g8 =
    _vm.showError && _vm.isError && !_vm.loading
      ? _vm.$u.addUnit(_vm.height)
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        s0: s0,
        g0: g0,
        g1: g1,
        g2: g2,
        g3: g3,
        g4: g4,
        g5: g5,
        g6: g6,
        g7: g7,
        g8: g8,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }